<template>
  <form @submit.prevent="onSubmit">
    <div class="form-row align-items-center">
      <div class="col-auto">
        <label class="sr-only" for="amount">Лимит</label>
        <input
            class="form-control"
            v-model.number="local.amount"
            ref="amountRef"
            placeholder="1000"
            inputmode="decimal"
            required
        >
      </div>
      <div class="col-auto" v-if="local.id === ''">
        <label class="sr-only" for="category">Категория</label>
        <select
            id="category"
            class="form-control mb-2 form-select"
            v-model="local.categoryId"
        >
          <option
              v-for="cat in categories"
              :key="cat.id"
              :value="cat.id"
              :selected="local.categoryId === cat.id"
          >
            {{ cat.name }}
          </option>
        </select>
      </div>
      <div class="text-danger g-3 mt-3 d-flex justify-content-center align-items-center" v-if="props.errorMessage">
        <span>{{ props.errorMessage }}</span>
      </div>
      <div class="d-flex justify-content-center mt-3 gap-3">
        <button class="btn btn-primary mb-2" type="submit">
          Сохранить
        </button>

        <button class="btn btn-danger mb-2" v-if="local.id" @click="emit('delete', local)">
          Удалить
        </button>
      </div>

    </div>
  </form>
</template>

<script setup>
import {onMounted, reactive, ref, watch} from 'vue';
import {normalizeAmountInput, toLocalInputValue} from "@/api/helpers";

const props = defineProps({
  categories: { type: Array, required: false },
  initial: {type: Object, required: false },
  errorMessage: {type: String, required: false },
});
const local = reactive({
  id: props.initial?.id ?? '',
  amount: props.initial?.amount != null ? Math.abs(props.initial.amount) : '',
  categoryId: props.initial?.categoryId ?? '',
});
const emit = defineEmits(['submit', 'delete']);

function onSubmit() {
  emit('submit', {...local});
}

const amountRef = ref(null);
onMounted(async () => {
  normalizeAmountInput(amountRef);
});

</script>
